// extracted by mini-css-extract-plugin
export default {"wrapper":"UserIcon_wrapper__Toitk","picture":"UserIcon_picture__MpdqS","name":"UserIcon_name__DqycC"};